import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Tile, TileComment, TileHeader } from '../common/Tile';
import VideoPlayer from '../common/VideoPlayer';
import { LinkedInShareButton } from '../common/ShareButton';
import { collectActivity } from '../../hooks/analytics';
export default function VideoContent(props) {
    // For staging/production
    var href = document.location.href;
    // For development (can't share localhost to LinkedIn):
    // const href = 'https://bootstrapworks.com/events/zuQhzGRAbmgY/content/dGGpqRDb0Qqq';
    return (_jsxs(Tile, { children: [_jsxs(TileHeader, { children: [props.title, " "] }, void 0),
            _jsx(VideoPlayer, { url: props.url, startAt: props.startAt, onProgress: props.onProgress, onPlay: function () {
                    // Analytics
                    void collectActivity('play', 'content', props.contentId);
                } }, void 0),
            _jsx(TileComment, { children: props.description }, void 0),
            _jsx(LinkedInShareButton, { url: href }, void 0)] }, void 0));
}
//# sourceMappingURL=VideoContent.js.map